angular.module('impactx.util').controller('AmountInputCtrl', [
    '$scope',
    'TranslationService',
    AmountInputCtrl]);

function AmountInputCtrl($scope, TranslationService) {
    var self = this;
    self.trns = {
        required: TranslationService.get('required')
    }
}